import React, { useState, useEffect } from "react";
import { getIdData } from "../../../lib/studentinfo"
import { addData } from "../../../lib/taskm"
import { getIdData as getClassData } from "../../../lib/class"
import { getDataWithClass,getStudentClass } from "../../../lib/classdetailview"
import { TaskTopic911Select, TaskTopic12Select } from "../../ui/myselect";
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from "../../../usercontext";
import TextEditor from "../../ui/editor";

export default function TaskManage() {

  const [desc, setDesc] = useState();
  const [studentClass, setStudentClass] = useState();
  const [toInfo, setToInfo] = useState("");
  const [classDetail, setClassDetail] = useState([]);
  const [taskTopic, setTaskTopic] = useState(null);
  const { profile, setProfile } = useAuth();
  const [instructorId, setInstructorId] = useState();
  const navigate = useNavigate();
  let { slug, type } = useParams();

  const [date, setDate] = useState()

	const getCurrentDateInput = () => {
		const dateObj = new Date()

		// get the month in this format of 04, the same for months
		const month = ('0' + (dateObj.getMonth() + 1)).slice(-2)
		const day = ('0' + dateObj.getDate()).slice(-2)
		const year = dateObj.getFullYear()

		const shortDate = `${year}-${month}-${day}`

		setDate(shortDate)
	}

	async function GetStudentData() {
		const info = await getIdData(slug)
		const classinfo = await getStudentClass(slug)

		setInstructorId(classinfo[0].instructorId)

		setToInfo(info[0].name + ' ' + info[0].surname)
		setStudentClass(info[0].class)
	}

	async function GetClassData() {
		const info = await getClassData(slug)
		setToInfo(info[0].class_name)
		setStudentClass(info[0].grade)

		const classinfo = await getDataWithClass(slug, profile.id)
		setClassDetail(classinfo)
	}

	const handleSubmit = async (e) => {
		e.preventDefault()

		if (type === 'Student') {
			await addData({
				from: instructorId,
				to: slug,
				setDate: date,
				subject: taskTopic,
				desc: desc
			})
		}

		if (type === 'Class') {
			classDetail.map(async function (data) {
				await addData({
					from: data.instructorId,
					to: data.studentId,
					setDate: date,
					subject: taskTopic,
					desc: desc
				})
			})
		}
		navigate(-1)
	}

	useEffect(() => {
		getCurrentDateInput()
		if (type === 'Student') {
			GetStudentData()
		}
		if (type === 'Class') {
			GetClassData()
		}
	}, [])
  return (
    <>
      <div className="settings-widget profile-details">
        <div className="settings-menu p-0">
          <div className="profile-heading">
            <h3>{type === "Student" ? "Add Item to Student" : "Add Item to Class"}</h3>
          </div>
          <div className="checkout-form personal-address add-course-info ">
            <form role="form" onSubmit={handleSubmit}>
              <div className="row mx-auto">
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">
                      To
                    </label>
                    <h5>{toInfo}</h5>
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">
                      Topic
                    </label>
                    {studentClass > 11 ?
                      <TaskTopic12Select value={taskTopic} setValue={setTaskTopic} />
                      :
                      <TaskTopic911Select value={taskTopic} setValue={setTaskTopic} />
                    }
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group w-50">
                    <label className="form-control-label">
                      Date
                    </label>
                    <input type="date"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                      className="form-control" />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">Description</label>
                    <div id="editor">
                      <TextEditor value={desc} setValue={setDesc} />
                    </div>
                  </div>
                </div>
                <div className="update-profile d-flex justify-content-between">
                  <button type="submit" className="btn btn-primary">
                    {type === "Add" ? "Add Item" : "Update Item"}
                  </button>
                  <button onClick={() => navigate(-1)} className="btn btn-black btn-sm">
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
